import Vue from 'vue'
import router from '../../router/';
import {
  AUTH_LOGIN,
  AUTH_LOGOUT,
  CHANGE_USER_WORK_STATUS,
  CREATE_USER,
  EDIT_BALANCE,
  EDIT_SUPPORT_LIMIT,
  EDIT_USER,
  EDIT_USER_MASS,
  LOAD_FINISHED_HISTORY, LOAD_FINISHED_USERS,
  LOAD_USERS_LIST, RESET_FINISHED_HISTORY,
  RESET_SUPPORT_LIMIT,
} from '../const/user';
import { HTTP_GET, HTTP_POST, HTTP_PUT } from '../const';
import { RESET_ORDERS } from "../const/orders";
import { RESET_SETTINGS } from "../const/settings";

export default {
  namespaced: true,
  state: {
    id: localStorage.getItem('id') || '',
    token: localStorage.getItem('token') || '',
    username: localStorage.getItem('username') || '',
    role: localStorage.getItem('role') || '',
    users: [],
    balanceHistory: {
      stats: {
        total: {},
        exchanges: {},
      },
      history: [],
      pagination: {},
      loaded: null,
    },
    finishedHistory: {
      stats: {
        total: {},
        exchanges: {},
      },
      loaded: null,
    },
    balanceUsers: [],
    finishedUsers: [],
  },
  getters: {
    getRole: state => state.role,
    getToken: state => state.token,
    isAdmin: state => state.role === 'admin' || state.role === 'superadmin',
    isPartner: state => state.role === 'partner',
    isSupport: state => state.role === 'support',
    users: state => state.users,
    requisites: state => state.requisites,
    requisitesUsers: state => state.requisitesUsers,
    username: state => state.username,
    finishedHistory: state => state.finishedHistory,
    finishedUsers: state => state.finishedUsers,
  },
  actions: {
    [AUTH_LOGIN]: async ({ dispatch, commit }, { name, password, data }) => {
      const request = await dispatch(HTTP_POST, {
        method: AUTH_LOGIN,
        body: { name, password, data },
        with_token: false,
        no_commit: true,
        namespace: 'user',
      }, { root: true });

      if (request && request.data && request.data.data) {
        const data = request.data.data;
        const token = data.token;
        const user = data.user;
        localStorage.setItem('token', token);
        localStorage.setItem('id', user.id);
        localStorage.setItem('username', user.name);
        localStorage.setItem('role', user.role);

        commit(AUTH_LOGIN, {
          token,
          id: user.id,
          username: user.name,
          role: user.role,
        });
        await router.push({ name: 'OrdersList' });
      }
    },
    [AUTH_LOGOUT]: async ({ commit }) => {
      commit(`orders/${RESET_ORDERS}`, null, { root: true });
      commit(`settings/${RESET_SETTINGS}`, null, { root: true });
      commit(AUTH_LOGOUT);
      await router.push({ name: 'Login' });
    },
    [LOAD_USERS_LIST]: async ({ dispatch }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_USERS_LIST,
        namespace: 'user',
      }, { root: true });
    },
    [CREATE_USER]: async ({ dispatch }, user) => {
      const request = await dispatch(HTTP_POST, {
        method: CREATE_USER,
        namespace: 'user',
        body: user,
        no_commit: true,
      }, { root: true });
      if (request && request.data) {
        return request.data;
      } else {
        return { success: false, message: 'Bad request' };
      }
    },
    [EDIT_USER]: async ({ dispatch }, { id, data }) => {
      const request = await dispatch(HTTP_PUT, {
        method: EDIT_USER,
        namespace: 'user',
        body: data,
        replace: { id },
        no_commit: true,
      }, { root: true });
      if (request && request.data) {
        return request.data;
      } else {
        return { success: false, message: 'Bad request' };
      }
    },
    [EDIT_BALANCE]: async ({ dispatch }, { id, data }) => {
      const request = await dispatch(HTTP_PUT, {
        method: EDIT_BALANCE,
        namespace: 'user',
        body: data,
        replace: { id },
        no_commit: true,
      }, { root: true });
      if (request && request.data) {
        return request.data;
      } else {
        return { success: false, message: 'Bad request' };
      }
    },
    [EDIT_SUPPORT_LIMIT]: async ({ dispatch }, { id, data }) => {
      const request = await dispatch(HTTP_PUT, {
        method: EDIT_SUPPORT_LIMIT,
        namespace: 'user',
        body: data,
        replace: { id },
        no_commit: true,
      }, { root: true });
      if (request && request.data) {
        return request.data;
      } else {
        return { success: false, message: 'Bad request' };
      }
    },
    [RESET_SUPPORT_LIMIT]: async ({ dispatch }, { id }) => {
      const request = await dispatch(HTTP_PUT, {
        method: RESET_SUPPORT_LIMIT,
        namespace: 'user',
        replace: { id },
        no_commit: true,
      }, { root: true });
      if (request && request.data) {
        return request.data;
      } else {
        return { success: false, message: 'Bad request' };
      }
    },
    [EDIT_USER_MASS]: async ({ dispatch }, body) => {
      const request = await dispatch(HTTP_PUT, {
        method: EDIT_USER_MASS,
        namespace: 'user',
        body,
        no_commit: true,
      }, { root: true });
      if (request && request.data) {
        return request.data;
      } else {
        return { success: false, message: 'Bad request' };
      }
    },
    [CHANGE_USER_WORK_STATUS]: async ({ dispatch }, { data, status }) => {
      const request = await dispatch(HTTP_PUT, {
        method: CHANGE_USER_WORK_STATUS,
        namespace: 'user',
        replace: { status },
        body: data,
        no_commit: true,
      }, { root: true });
      if (request && request.data) {
        return request.data;
      } else {
        return { success: false, message: 'Bad request' };
      }
    },
    [LOAD_FINISHED_HISTORY]: async ({ dispatch, commit }, body) => {
      commit(RESET_FINISHED_HISTORY);
      const request = await dispatch(HTTP_POST, {
        method: LOAD_FINISHED_HISTORY,
        body,
        no_commit: true,
        namespace: 'user',
      }, { root: true });
      if (request && request.data) {
        if (request.data.success) {
          commit(LOAD_FINISHED_HISTORY, request.data);
        }
        return request.data;
      } else {
        return { success: false, message: 'Bad request' };
      }
    },
    [LOAD_FINISHED_USERS]: async ({ dispatch }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_FINISHED_USERS,
        namespace: 'user',
      }, { root: true });
    },
  },
  mutations: {
    [AUTH_LOGIN]: (state, { token, id, username, role }) => {
      Vue.set(state, 'token', token);
      Vue.set(state, 'id', id);
      Vue.set(state, 'username', username);
      Vue.set(state, 'role', role);
    },
    [AUTH_LOGOUT]: (state) => {
      localStorage.clear();
      Vue.set(state, 'token', '');
      Vue.set(state, 'id', '');
      Vue.set(state, 'username', '');
      Vue.set(state, 'role', '');
      Vue.set(state, 'users', []);
      Vue.set(state, 'requisites', []);
      Vue.set(state, 'requisitesUsers', []);
    },
    [LOAD_USERS_LIST]: (state, { data = {} }) => {
      if (data.users) {
        Vue.set(state, 'users', data.users);
      }
    },
    [LOAD_FINISHED_HISTORY]: (state, { data }) => {
      Vue.set(state, 'finishedHistory', data);
      Vue.set(state.finishedHistory, 'loaded', Date.now());
    },
    [RESET_FINISHED_HISTORY]: (state) => {
      const default_history = {
          stats: {
            total: {},
            exchanges: {},
          },
          loaded: null,
        };
      Vue.set(state, 'finishedHistory', default_history);
    },
    [LOAD_FINISHED_USERS]: (state, { data }) => {
      Vue.set(state, 'finishedUsers', data);
    },
  },
};
